"use strict";
/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * https://github.com/Shopify/slate.git.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Adds a Shopify size attribute to a URL
 *
 * @param src
 * @param size
 * @returns {*}
 */
function imageUrl(src, size) {
    if (!src || typeof src !== "string")
        return null;
    typeof size === "number" ? (size = size + "x" + size) : null;
    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
    }
    else {
        return null;
    }
    return !size || size == "master" || !src.match(/cdn/i) ? removeProtocol(src) : removeProtocol(prefix[0] + "_" + size + suffix);
}
exports.imageUrl = imageUrl;
function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
}
exports.removeProtocol = removeProtocol;
/**
 * Adds a Shopify size attribute to a URL
 *
 * @param src
 * @param size
 * @returns {*}
 */
function getSizedImageUrl(src, size) {
    if (!src) {
        return "";
    }
    if (size === null || src.includes("googleapis")) {
        return src;
    }
    if (size === "master") {
        return removeProtocol(src);
    }
    var sized = src.match(/(_\d+x\d+)|(_\d+x)/);
    if (sized && sized.length) {
        // already sized asset
        return src;
    }
    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
        return removeProtocol(prefix[0] + "_" + size + suffix);
    }
    return null;
}
exports.getSizedImageUrl = getSizedImageUrl;
